import React, { FC, useState } from 'react';
import Table from '../../../../Components/Layout/Table';
import AiAuditLogTable from '../../../../Table/Admin/Edition/AiAuditLogTable';
import { useOutletContext } from 'react-router-dom';

const AuditLogsPage: FC = () => {
    const [toggleReload] = useState<boolean>(true);
    const outlet = useOutletContext<[boolean, (show: boolean) => void, string, (search: string) => void]>();
    const search = outlet && outlet[2] ? outlet[2] : '';
    const setSearch = outlet && outlet[3] ? outlet[3] : () => {};
    const [logs, setLogs] = useState<any[]>([]);

    const dateRender = (log: any) => {
        if (!log.createdAt) return '';
        const d = new Date(log.createdAt);
        return `${d.toISOString().slice(0, 10)} ${d.toTimeString().slice(0, 8)}`;
    };

    const providerRender = (log: any) => (
        <div>
            <span className="badge bg-secondary text-muted me-2 text-uppercase font-monospace" style={{ fontSize: '0.7rem' }}>
                {log.provider}
            </span>
            <code className="text-secondary small text-muted bg-light px-2 py-1 rounded border">{log.model}</code>
        </div>
    );

    const statusRender = (log: any) => {
        const isSuccess = log.status === 'success' || log.status?.value === 'success';
        return (
            <span className={`badge ${isSuccess ? 'bg-success' : 'bg-danger'}`}>
                {isSuccess ? 'Success' : 'Failed'}
            </span>
        );
    };

    const durationRender = (log: any) => `${log.processingTimeMs ?? 0} ms`;
    const tokensRender = (log: any) => {
        const total = (log.totalTokens && log.totalTokens > 0) 
            ? log.totalTokens 
            : ((log.inputTokens ?? 0) + (log.outputTokens ?? 0));
        return `${total.toLocaleString()} tok`;
    };

    let rows = { ...AiAuditLogTable };
    if (rows.createdAt) rows.createdAt.render = dateRender;
    if (rows.provider) rows.provider.render = providerRender;
    if (rows.status) rows.status.render = statusRender;
    if (rows.processingTimeMs) rows.processingTimeMs.render = durationRender;
    if (rows.totalTokens) rows.totalTokens.render = tokensRender;

    return (
        <Table
            path="/admin/edition/ai/audit-logs"
            rows={rows}
            toggleReload={toggleReload}
            items={logs}
            setItems={setLogs}
            keyword={search}
            setKeyword={setSearch}
        />
    );
};

export default AuditLogsPage;
